import {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {MeetingRoomInfo} from './meeting-room-status.styles';

interface MeetingRoomStatusProps {
  meetingRoomStatus: boolean;
  timeRemaining: string;
}

const MeetingRoomStatus = ({meetingRoomStatus, timeRemaining}: MeetingRoomStatusProps) => {
  const {t} = useTranslation();

  if (typeof meetingRoomStatus === 'undefined') return null;

  return (
    <MeetingRoomInfo isBusy={meetingRoomStatus} type="h3">
      {meetingRoomStatus ? t('rooms.occupied') : t('rooms.free')}
      {!!timeRemaining && ` (${timeRemaining})`}
    </MeetingRoomInfo>
  );
};

export default memo(MeetingRoomStatus);
